













import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        InputNumber: InputNumber
    },
    data: function() {
        return {
            pathInStore: "property.land.landWidth"
        };
    },
    computed: {
        plotWidth: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(plotWidth: number): void {
            if (plotWidth == 0 && this.$store.getters["FormModule/getValue"](this.pathInStore) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                if (plotWidth != 0) {
                    this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": plotWidth});
                }
            }
        }
    }
});

